import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./modal.module.css";

const CustomModal = ({
	show,
	onHide,
	children,
	modalId = "",
	modalClass = "",
	hideCloseButton = false,
	customClassBody,
	customClassModal 
}) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
		return () => setMounted(false);
	}, []);

	if (!show || !mounted) return null;

	// const overlayStyle = {
	// 	position: 'fixed',
	// 	top: 0,
	// 	left: 0,
	// 	width: '100vw',
	// 	height: '100vh',
	// 	backgroundColor: 'rgba(0, 0, 0, 0.8)',
	// 	display: 'flex',
	// 	justifyContent: 'center',
	// 	alignItems: 'center',
	// 	zIndex: 2147483647,
	// 	backdropFilter: 'blur(3px)'
	// };

	// const modalStyle = {
	// 	backgroundColor: 'white',
	// 	borderRadius: '12px',
	// 	boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
	// 	position: 'relative',
	// 	maxWidth: '90vw',
	// 	maxHeight: '90vh',
	// 	overflow: 'hidden',
	// 	border: '1px solid rgba(255, 255, 255, 0.2)',
	// 	animation: 'modalFadeIn 0.3s ease-out',
	// 	zIndex: 2147483647
	// };

	const modalContent = (
		<div 
			className={`${styles.customModalOverlay} ${modalClass || ''} customModalOverlay`} 
			id={modalId}
			// style={overlayStyle}
		>
			<div 
				className={`${styles.customModal} ${customClassModal || ''} modalContent`}
				// style={modalStyle}
			>
				{!hideCloseButton && (
					<button className={styles.closeButton} onClick={() => onHide?.()}>
						&times;
					</button>
				)}

				<div className={`${styles.customModalBody} ${customClassBody || ''} modalBody`}>
					{children}
				</div>
			</div>
		</div>
	);

	// Render directly to document body using Portal
	return createPortal(modalContent, document.body);
};

export default CustomModal;
